module.exports = __webpack_public_path__ + "img/iconfont.b0a75527.svg";